import InlineTags from "@entrilia/shared/components/InlineTags";
import useClientContext from "../../context/useClientContext";

interface CommonProps {
  maxDisplayedCategories?: number;
  noWrap?: boolean;
}

interface ExternalIdsProps extends CommonProps {
  externalCategoryIds: string[];
  categoryIds?: never;
}

interface InternalIdsProps extends CommonProps {
  categoryIds: string[];
  externalCategoryIds?: never;
}

type Props = ExternalIdsProps | InternalIdsProps;

const CategoryInlineTags = (props: Props) => {
  const { getAccessCategoryByExternalId, getAccessCategoryById } = useClientContext();

  const categories =
    props.categoryIds !== undefined
      ? props.categoryIds.map((id) => getAccessCategoryById(id))
      : props.externalCategoryIds.map((externalId) => getAccessCategoryByExternalId(externalId));

  const tags = categories
    .filter((category) => category !== undefined)
    .map((category) => ({ label: category.name, color: category.effectiveColor }));

  return <InlineTags tags={tags} maxDisplayedTags={props.maxDisplayedCategories} noWrap={props.noWrap} />;
};

export default CategoryInlineTags;
